import React, { useState } from "react";
import "./FAQ.css";

export default function FAQ() {
  const [showAll, setShowAll] = useState(false);

  const handleToggle = () => {
    setShowAll(!showAll);
  };

  return (
    <div className="FAQ-Body">
      {faqData.slice(0, showAll ? faqData.length : 5).map((faq, index) => (
        <FAQContent
          key={index}
          count={(index + 1).toString().padStart(2, '0')}
          text={faq.question}
          answer={faq.answer}
        />
      ))}
      <button className="FAQ-Button" onClick={handleToggle}>
        {showAll ? "See Less" : "See More"}
      </button>
    </div>
  );
}

const faqData = [
  {
    question: "What is your educational background?",
    answer: "I have a Bachelor's degree in Computer Science & Engineering from Daffodil International University."
  },
  {
    question: "What programming languages are you proficient in?",
    answer: "I am proficient in C, C++, JavaScript, TypeScript, HTML5, and CSS."
  },
  {
    question: "Which frameworks and libraries do you have experience with?",
    answer: "I have experience with React.js, React Native, Next.js, Express.js, Node.js, Bootstrap, Tailwind, and IoT."
  },
  {
    question: "What tools do you use for development?",
    answer: "I use Git, GitHub, VS Code, and Figma for my development projects."
  },
  {
    question: "Can you describe some of your past projects?",
    answer: "I have worked on various projects including EDU PLANET, BUY NOW, HANDOFF, SMIRA CLUB FOR BOOKING HOTELS AND DEALS, and IOT BASED SMART STREET LIGHT, among others."
  },
  {
    question: "What was your role at Scientistx Technology?",
    answer: "I worked as a Software Developer at Scientistx Technology in 2022."
  },
  {
    question: "What experience do you have with freelance work?",
    answer: "I have worked as a Web Developer on Fiverr from 2023 to 2024, delivering high-quality web solutions to clients."
  },
  {
    question: "What is your approach to learning new technologies?",
    answer: "I am highly adaptable and self-motivated, always eager to learn and incorporate new technologies to solve challenges efficiently."
  },
  {
    question: "What languages do you speak?",
    answer: "I am fluent in Bangla and English."
  },
  {
    question: "How can someone contact you?",
    answer: "You can reach me via email at <a href='mailto:tasnimshahriarakash@gmail.com'>tasnimshahriarakash@gmail.com</a> or call me at <a href='tel:+8801580233165'>01580233165</a>. My portfolio is available at <a href='https://tasnim-s-akash.web.app' target='_blank'>https://tasnim-s-akash.web.app</a>."
  }
];

function FAQContent({ count, text, answer }) {
  return (
    <div className="FAQContent-Body">
      <div className="FAQContent-Left">
        <p className="FAQContent-Text1">{count}.</p>
      </div>
      <div className="FAQContent-Right">
        <p className="FAQContent-Text2">{text}</p>
        <p
          className="FAQContent-Text3"
          dangerouslySetInnerHTML={{ __html: answer }}
        ></p>
      </div>
    </div>
  );
}
